export default function TrustMetricsBar() {
  const metrics = [
    { icon: 'ri-refresh-line', label: 'Updated Weekly', desc: 'PandabuySpreadsheet Collections' },
    { icon: 'ri-database-2-line', label: '10,000+ Items', desc: 'Curated & Indexed' },
    { icon: 'ri-price-tag-3-line', label: 'Budget to Premium', desc: 'All Price Categories' },
    { icon: 'ri-smartphone-line', label: 'Mobile Optimized', desc: 'Shop Anywhere, Anytime' },
  ];

  return (
    <section className="py-8 md:py-10 bg-background-50 border-y border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {metrics.map((m) => (
            <div key={m.label} className="flex items-center gap-3 md:gap-4">
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 flex-shrink-0">
                <i className={`${m.icon} text-lg md:text-xl`}></i>
              </span>
              <div>
                <p className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">{m.label}</p>
                <p className="text-xs text-foreground-500">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}